import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Card, Col, Row } from "antd";
import { grayheader, cardmargin } from "../../CSSReferences";


export interface LocalProps{
  //defince local porperies (maybe as tag parameter)
  // ONLY TYPES; NO VALUES
    id:string;
    url:string;
    loginuser:string;
    loginrole:number;
  // FUNCTIONS ALSO INCLUDE
  onSubmit: (data:any, password:string, passwordverification:string) => void;
}

enum GenderEnum {
  female = "female",
  male = "male",
  other = "other"
}

enum RoleEnum {
  admin = "admin",
  user = "user"
}

interface IFormInputs {
  name:string
  email:string
  username: string
  password: string
  passwordverification:string
  gender:GenderEnum
  role:RoleEnum
}

// const onFinish = (values: any) => {
  const schema = yup.object().shape({
    name: yup.string().required(),
    email:yup.string().email('Invalid Email Format').required('Required'),
    username: yup.string().required(),
    password: yup.string().required().matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{10,32}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"),
    // yup 1.x erwartet unter `then` eine Funktion, die das Schema umformt -
    // frueher stand dort das Schema selbst.
    //
    // Die Bedingung bleibt bewusst unveraendert, obwohl sie nicht tut, was sie
    // vorgibt: `is` vergleicht den **Wert** von `password` mit der Zeichenkette
    // "passwordverification". Der trifft nie zu, also ist das Feld faktisch
    // nie erforderlich und eine abweichende Wiederholung wird nicht bemerkt.
    // Gemeint war vermutlich `oneOf([yup.ref('password')])`. Das gehoert
    // entschieden und geprueft, nicht nebenbei in einer Umstellung geaendert.
    passwordverification:yup.string().ensure().when('password',{
      is:'passwordverification',
      then: (schema) => schema.required()
      }),
  });


  const makeString = (amount:number): string => {
    let outString: string = '';
    let inOptions: string = 'abcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < amount; i++) {
      outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
    }

    return outString;
  }


  // I can export a class or a const(function) of this. 
  // Minor differences
export const LoginView = (props:LocalProps) => {
  const { register, handleSubmit, formState: { errors } } = useForm<IFormInputs>({
    // yup 1.x leitet einen breiteren Schematyp ab, als das Formular deklariert
    // (gender und role stehen in IFormInputs, aber nicht im Schema). Die
    // Laufzeitpruefung bleibt davon unberuehrt.
    resolver: yupResolver(schema) as any
  });

  const onSubmit = (data: IFormInputs)  => {
    console.log(data);
    const encode = (str: string):string => btoa(str);
    props.onSubmit(data, encode(data.password), encode(data.password));
    
  }
if (props.loginrole !== 2)
{
  return(
    <div></div>)
}
 
return (
  <Row gutter={16}>
      <Col span={8}></Col>
      <Col span={8}>
    <Card title="Create a new User" style={cardmargin} hoverable styles={{ header: grayheader }}>
    <form onSubmit={handleSubmit(onSubmit)}>
        {/* register your input into the hook by invoking the "register" function */}
        <Row gutter={16}>
          <Col span={8}>
          <label>Full Name </label>
          </Col>
          <Col span={10}>    
          <input placeholder="Full Name" {...register("name")} />
          {errors.name && <span>This field is required</span>}
          </Col>
          <Col span={8}></Col>
          </Row> 
        <Row gutter={16}>
        <Col span={8}>
        <label>Username </label>
        </Col>
        <Col span={8}>
        <input placeholder="Username" {...register("username")} />
        {errors.username && <span>This field is required</span>}
        </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
          <label>E-Mail </label>
          </Col>
          <Col span={16}>    
          <input placeholder="E-Mail" {...register("email")} />
          {errors.email && <span>This is no known email format</span>}
          </Col>
          <Col span={8}></Col>
          </Row> 
        <Row gutter={16}>
        <Col span={8}>
        <label>Password </label>
        </Col>
        <Col span={8}>
        {/* include validation with required or other standard HTML validation rules */}
        <input  type="password" {...register("password", { required: true })} />
        {/* errors will return when field validation fails  */}
        {errors.password && <span>This field is required. Requirements: <ul><li>10  characters</li><li>1+ capital letter</li><li>1+ numeric character</li><li>special character (@$!%*#?&amp;)</li></ul></span>}
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
        <label>Repeat Password </label>
        </Col>
        <Col span={8}>
        {/* include validation with required or other standard HTML validation rules */}
        <input type="password" {...register("passwordverification", { required: true })} />
        {/* errors will return when field validation fails  */}
        {errors.passwordverification && <span>This field is required</span>}
        </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
          <label>Role </label>
          </Col>
          <Col span={16}>    
          <select {...register("role")} >
          <option value="admin">admin</option>
          <option value="user">user</option>
          </select>
          {errors.role && <span>This is no known role format</span>}
          </Col>
          <Col span={8}></Col>
          </Row> 
        <Row gutter={16}>
        <Col span={8}><label>Gender</label></Col>
        <Col span={8}>
        <select {...register("gender")} >
        <option value="female">female</option>
        <option value="male">male</option>
        <option value="other">other</option>
      </select>
   
        </Col>
        </Row>


        <Row gutter={16}>
        <Col span={16}></Col>
        <Col span={8}>
        <input type="submit" value="Create User"/>
        </Col>
        </Row>
      </form>
      </Card>
    </Col>
    <Col span={8}></Col>
     {/* <div>{props.loginuser}</div> FIXME: purpose, Thas how I can Access THe variables from a global state NO THIS */}
    </Row>
    )
};